
module.exports = Object.freeze({
     status:{
        NOT_COMPLETE:'Not Complete',
        COMPLETE:'Complete',
        COMPLETED:'Completed',
        IN_PROGRESS: 'In Progress',
        FOR_APPROVAL:'For Approval',
        CHANGE_REQUESTED:'Change Requested',
        FOR_REVIEW: 'For Review',
        MODIFIED:'modified'

    },
    api:{
       PAGE_NOT_FOUND: 'Page Not found',
       INACTIVE_PROJECT:'Inactive Project',
       NOT_FOUND: 'Not Found!',
       ID_IS_REQUIRED: 'Id is required.',
       TEMPLATE_INDEX: './template/index',
       PAGE_NOT_AVAILABLE: ' - pageNotAvailable',
       WORKSTREAM: ' - Workstream',
       CONVERSATION: ' - Conversations'
    },
    members_status:{
       INVITED:'invited',
       DISABLED:'disabled',
       ENABLED:'enabled'
    },

    USER_PASS_ERROR: 'Incorrect username/password.',
    SUCCESS_LOGIN: 'Successfully Login',
    PROJ_MGR: 'project manager',
    DATEFORMAT:'YYYY-MM-DD',
    DATEFORMAT_NEW:'DD-MMM YYYY',
    DATETIMEFORMAT:'YYYY-MM-DD HH:mm',
    DATETIMEFORMAT_FULL:'YYYY-MM-DD HH:mm:ss',
    DATETIMEFORMAT_FULL_NEW:'DD-MMM YYYY HH:mm:ss',
    ERROR_401: 'Unauthorized Access',
    USER_TYPE_QUERY: 'SELECT * FROM users ',
    USER_TYPE: 'userType',
    USER_TEAM : '/users',
    USERS: 'users',
    INTERNAL: 'Internal',
    ALL_MONTHS: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    FRONT_BROADCAST_COMMENT_LIST:'FRONT_BROADCAST_COMMENT_LIST',
    WELCOME_TO_CLOUDCFO:"Welcome to CloudCfo | Activate Your Account",
    YOUR_TASK_HAS_BEEN_APPROVED:"Your Task has been Approved",
    REQUIRED_NUMBER_OF_ACTIVE_RECURRING_TASKS: 3,
    MONTHS_NUMBERS: {
      'Jan' : 0, 
      'Feb' : 1, 
      'Mar' : 2, 
      'Apr' : 3, 
      'May' : 4, 
      'Jun' : 5, 
      'Jul' : 6, 
      'Aug' : 7, 
      'Sep' : 8, 
      'Oct' : 9, 
      'Nov' : 10, 
      'Dec' : 11
  },
});